export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "25", page: 25 },
  { text: "50", page: 50 },
  { text: "100", page: 100 },
  { text: "200", page: 200 }
];
export const initialFilter = {
  filter: {},
  sortOrder: "asc", // asc||desc
  sortField: "section",
  pageNumber: 1,
  pageSize: 25,
};